export default function getResource(label, vars = []) {
    const resources = {
        digitalProductFlashSubTitle: 'Free shipping with no minimum for one year',
        digitalProductRewardsSubTitle: 'Exchange 2500 points for $100 Rouge Reward',
        productNotFound: 'Product not found',
        subtitle: `Exchange ${vars[0]} points for ${vars[1]} Rouge Reward`
    };
    return resources[label];
}
